import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import searcher from "../../../assets/searchInput.svg";
import { useDispatch } from "react-redux";
import TableContainer from "../../layouts/table-container/table-container";
import ErrorPopup from "../../popups/ErrorPopup";
import ChangeSaved from "../../popups/ChangeSaved";
import CloseIcon from "../../../assets/icons/closeIcon";
import "../../modals/bulk-upload/bulk-upload.css";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import Select from "react-select";
import { productPharmacyOfferRequest } from "../../../redux/actions/productActions";
import LoadingSpinnerTable from "../../utilites/loader";
import {
  parmacyOnboardProductList,
  pharmacyProductOfferList,
} from "../../../redux/actions/customerActions";
import { useParams } from "react-router-dom";
import AddPharmacyProductModal from "./addPharmacyProductModal";

const OnbaordPharmacyProductsTableModal = ({
  show,
  ShowClose,
  divisionList,
  state_id,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const [offerList, setOfferList] = useState([]);
  const [loading, setloading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [filterProductArray, setfilterproductrArray] = useState([]);
  const [productVerifiedList, setProductVerifiedList] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [addProduct, setAddProduct] = useState(false);

  useEffect(() => {
    if (show) {
      setloading(true);
      dispatch(
        parmacyOnboardProductList(
          { pharmacy_id: params?.id },
          onPharmacySuccess,
          onPharmacyError
        )
      );
    }
  }, [show]);

  const fetchProductOffer = (product_id) => {
    if (product_id) {
      dispatch(
        pharmacyProductOfferList(
          {
            pharmacy_id: params?.id,
            product_id: product_id,
          },
          (data) => onListSuccess(data, product_id),
          onGetError
        )
      );
    }
  };

  const onListSuccess = (data, product_id) => {
    console.log(data);
    setOfferList((prev) => ({
      ...prev,
      [product_id]: data.data.data.product.offers.map((ele) => ({
        value: ele?.id,
        label:
          ele?.offer_type === "quantity"
            ? `${ele?.offer} + ${ele?.offer_qty}`
            : ele.after_off,
      })),
    }));
  };

  const onGetError = (err) => {
    console.log(err);
  };

  const onPharmacySuccess = (data) => {
    setProductList(data.data.data.fieldForceDivisions);
    setfilterproductrArray(data.data.data.fieldForceDivisions);
    setloading(false);
  };
  const onPharmacyError = (err) => {
    setloading(false);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const checkedProduct = (e, item) => {
    const { checked } = e.target;

    setProductVerifiedList((prevList) => {
      if (checked) {
        fetchProductOffer(item.product.id);
        return [
          ...prevList,
          {
            offer_id: "",
            request_id: item.id,
            pharmacy_id: params.id,
          },
        ];
      } else {
        return prevList.filter((obj) => obj.request_id !== item.id);
      }
    });
  };

  const handleOfferChange = (selectedOption, item) => {
    setProductVerifiedList((prevList) =>
      prevList.map((obj) =>
        obj.request_id === item.id
          ? { ...obj, offer_id: selectedOption.value }
          : obj
      )
    );
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const searchHandler = (e) => {
    let searchedText = e.target.value.toLowerCase();

    if (e.target.value === "") {
      setfilterproductrArray(productList);
    } else {
      let filteredDivisions = productList
        .map((division) => {
          const filteredOffers = division.productOffers.filter((offer) => {
            return (
              offer.product.product_name.toLowerCase().includes(searchedText) ||
              offer.product.company_product_id
                .toLowerCase()
                .includes(searchedText)
            );
          });

          return filteredOffers.length > 0
            ? { ...division, productOffers: filteredOffers }
            : null;
        })
        .filter(Boolean);
      setfilterproductrArray(filteredDivisions);
    }
  };

  const pharmacyOffersSubmit = () => {
    dispatch(
      productPharmacyOfferRequest(
        { pharmacyOffers: productVerifiedList },
        onPharmacyOfferSuccess,
        onPharmacyOfferError
      )
    );
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
  };

  const onPharmacyOfferSuccess = (data) => {
    ShowClose();
    setShowSuccessPopup(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
    setProductVerifiedList([]);
  };
  const onPharmacyOfferError = (err) => {
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const closeFnc = () => {
    setProductVerifiedList([]);
    ShowClose();
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={closeFnc}
        dialogClassName="doctor-data-table-container col-12 px-5 mx-auto"
        size="lg"
      >
        <ModalHeader className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between w-100 align-items-center">
            <span className="fn_Nunito fw_700 fs_22">Products</span>
            <button className="border-0 bg-white" onClick={() => closeFnc()}>
              <CloseIcon fill="black" width={"14px"} />
            </button>
          </div>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div className="modal-table-container">
            <div className="search-container d-flex justify-content-between ">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  className="search-input fw_400 px-2 text-dark"
                  type="text"
                  placeholder="Search Product here by Product Name and Code..."
                  onChange={searchHandler}
                />
              </div>
              <AdminButton
                background="#7065E4"
                color="white"
                width="180px"
                onClick={() => {
                  ShowClose();
                  setAddProduct(true);
                }}
              >
                <span className="m-2 fw_700">ADD PRODUCT</span>
              </AdminButton>
            </div>
            <TableContainer>
              <thead>
                <tr className="table-rows color_747f9e">
                  <th className="table-heads " width={"1%"}></th>
                  <th className="table-heads " width={"12%"}>
                    Product Code
                  </th>
                  <th className="table-heads " width={"9%"}>
                    Product Name
                  </th>
                  <th className="table-heads " width={"12%"}>
                    Offer
                  </th>
                </tr>
              </thead>
              <tbody style={{ position: "relative" }}>
                {loading === true ? (
                  <div className="list-spinner-container">
                    <LoadingSpinnerTable />
                  </div>
                ) : (
                  <>
                    {filterProductArray?.map((item, index) => (
                      <>
                        <tr className="table-rows1" key={index}>
                          <th
                            colspan="4"
                            className="table-heads fs_20 form-sub-details"
                            width={"100%"}
                          >
                            Division - {item?.vendorDivision?.name}
                          </th>
                        </tr>
                        {item.productOffers?.map((productOffer, indexs) => (
                          <tr className="table-rows1" key={indexs}>
                            <td className="table-each-row-data" width={"1%"}>
                              <input
                                type="checkbox"
                                className="superCheck"
                                id={`checkbox-${index}`}
                                name="prodcutsCheck"
                                onChange={(e) =>
                                  checkedProduct(e, productOffer)
                                }
                                checked={productVerifiedList.some(
                                  (obj) => obj.request_id === productOffer.id
                                )}
                              />
                            </td>
                            <td className="table-each-row-data">
                              {productOffer.product.product_id}
                            </td>
                            <td className="table-each-row-data">
                              {productOffer.product.product_name}
                            </td>
                            <td className="table-each-row-data">
                              {productVerifiedList.some(
                                (obj) => obj.request_id === productOffer.id
                              ) ? (
                                <div
                                  style={{ maxWidth: "140px" }}
                                  className="w-100 pe-2"
                                >
                                  <Select
                                    options={
                                      offerList[productOffer.product.id] || []
                                    }
                                    styles={customStyles}
                                    placeholder="Select offer"
                                    onChange={(selectedOption) =>
                                      handleOfferChange(
                                        selectedOption,
                                        productOffer
                                      )
                                    }
                                  />
                                </div>
                              ) : (
                                `${productOffer?.offer?.offer} + ${productOffer?.offer?.offer_qty}`
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ))}
                  </>
                )}
              </tbody>
            </TableContainer>
          </div>
          <div className="my-2 mt-4">
            {productVerifiedList.length > 0 && (
              <div className="d-flex gap-4 justify-content-end">
                <AdminButton
                  background="#7065E4"
                  color="white"
                  width="180px"
                  onClick={pharmacyOffersSubmit}
                >
                  <span className="m-2 fw_700">Confirm</span>
                </AdminButton>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
      <AddPharmacyProductModal
        divisionList={divisionList}
        state_id={state_id}
        show={addProduct}
        ShowClose={() => setAddProduct(false)}
      />
    </>
  );
};

export default OnbaordPharmacyProductsTableModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    padding: "0.1rem",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
